import {
  Sparkles,
  Calendar,
  Check,
  Star,
  Mail,
  Users,
  HelpCircle,
} from "lucide-react";

/* Subscription page tour, ported from the mobile "Subscription" mockup.
   The mockup's tour deliberately DRIVES the Monthly/Annual billing toggle:
   it walks the plans on monthly pricing, then flips to Annual and re-shows the
   paid tiers so the 17% saving is visible. We reproduce that here via each
   step's `onEnter` side-effect (a generic hook on the tour engine) calling the
   page's `setBillingCycle`. The redundant annual repeats of Free / Trust / FAQ
   from the mockup are dropped — only the two paid tiers change price, so only
   they are re-shown on annual.

   `setBillingCycle` is passed in from the page so the tour and the real toggle
   stay in sync. Steps whose target may be absent (the START HERE trial card is
   only shown to trial-eligible users; Pro + Newsletter only if the API returns
   that tier) are auto-skipped by the engine. */
export default function getSubscriptionTourSteps(setBillingCycle) {
  const month = () => setBillingCycle && setBillingCycle("month");
  const year = () => setBillingCycle && setBillingCycle("year");
  return [
    {
      cardSelector: '[data-tour="sub-start"]',
      targetSelector: '[data-tour="sub-start"]',
      icon: <Sparkles />,
      title: "Start here",
      text: "Kick off a 3-day free trial of Pro — full access, cancel anytime.",
      onEnter: month,
    },
    {
      cardSelector: '[data-tour="sub-toggle"]',
      targetSelector: '[data-tour="sub-toggle"]',
      icon: <Calendar />,
      title: "Compare plans",
      text: "Toggle between Monthly and Annual pricing. Annual saves 17%.",
      onEnter: month,
    },
    {
      cardSelector: '[data-tour="sub-free"]',
      targetSelector: '[data-tour="sub-free"]',
      icon: <Check />,
      title: "Free plan",
      text: "Browse cities with one detail view, one calculator use, and one job view per day.",
      onEnter: month,
    },
    {
      cardSelector: '[data-tour="sub-pro"]',
      targetSelector: '[data-tour="sub-pro"]',
      icon: <Star />,
      title: "Pro plan",
      text: "Unlimited everything. Start the 3-day trial from here.",
      onEnter: month,
    },
    {
      cardSelector: '[data-tour="sub-news"]',
      targetSelector: '[data-tour="sub-news"]',
      icon: <Mail />,
      title: "Pro + Newsletter",
      text: "Everything in Pro plus the weekly Insider newsletter.",
      onEnter: month,
    },
    {
      cardSelector: '[data-tour="sub-trust"]',
      targetSelector: '[data-tour="sub-trust"]',
      icon: <Users />,
      title: "Trusted by nurses",
      text: "9,000+ nurses, 21,000+ cities, updated weekly.",
      onEnter: month,
    },
    {
      cardSelector: '[data-tour="sub-faq"]',
      targetSelector: '[data-tour="sub-faq"]',
      icon: <HelpCircle />,
      title: "Frequently asked",
      text: "Answers on cancelling, trials, plan differences, and how take-home is calculated.",
      onEnter: month,
    },
    {
      cardSelector: '[data-tour="sub-toggle"]',
      targetSelector: '[data-tour="sub-toggle"]',
      icon: <Calendar />,
      title: "Annual billing",
      text: "Switch to Annual — the prices below update to yearly, saving 17%.",
      onEnter: year,
    },
    {
      cardSelector: '[data-tour="sub-pro"]',
      targetSelector: '[data-tour="sub-pro"]',
      icon: <Star />,
      title: "Pro, billed yearly",
      text: "On Annual, Pro is billed once a year — the price above updates to your 17% saving.",
      onEnter: year,
    },
    {
      cardSelector: '[data-tour="sub-news"]',
      targetSelector: '[data-tour="sub-news"]',
      icon: <Mail />,
      title: "Pro + Newsletter, yearly",
      text: "Pro + Newsletter is cheaper billed annually too — the same 17% saving applies.",
      onEnter: year,
    },
  ];
}
